export default class {
    constructor(options){
        if(options){
            this.client = options.client
            this.organizationID = options.organizationID
        }
    }
    fetch(options){
        let params = []
        let organizationID = options.organizationID
        delete options.organizationID

        for(let [key, value] of Object.entries(options)){
            params.push(`${key}=${value}`)
        }
        // mark ***
        return this.client.get(`/service-regions?${params.join('&')}`)
    }
}


// WEBPACK FOOTER //
// ./lib/apiClient/organizations/serviceRegions.js